import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, Col, Row } from "antd";
import { Button } from "reactstrap";
import axios from "../services/axios";
import { message } from "antd";
import moment from "moment";
import ReactLoading from "react-loading";
import { Pagination } from "antd";
import { DatePicker } from "antd";
import exportFromJSON from "export-from-json";
import isConsultant from "../services/isConsultant";
import swal from "sweetalert";
import useAxios from "../hooks/useAxios";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

const { RangePicker } = DatePicker;

const OCRReport = (props) => {
  const api = useAxios();
  const [load, setLoad] = useState(false);
  const [defaultDate, setDefaultDate] = useState([]);
  const [startDate, setStartDate] = useState();

  const [canViewAiReport, setCanViewAiReport] = useState(false);
  const [canDownloadAiReport, setCanDownloadAiReport] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const viewAllowed = await checkPermission(
        userRole,
        "ai_report_module",
        "view_ai_report"
      );
      const downloadAllowed = await checkPermission(
        userRole,
        "ai_report_module",
        "download_ai_report"
      );
      setCanViewAiReport(viewAllowed);
      setCanDownloadAiReport(downloadAllowed);
    } catch (err) {
      console.error("Error checking AI report permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  const loadCSV = async () => {
    try {
      const report_result = await api.get(
        `/documentsAutomation?StartDate=${
          defaultDate[0] ? defaultDate[0] : ""
        }&EndDate=${defaultDate[1] ? defaultDate[1] : ""}`,
        {
          tokenType: "user",
        }
      );

      return report_result.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      let startDate = moment(dateString[0]).format("YYYY-MM-DD");
      let endDate = moment(dateString[1]).format("YYYY-MM-DD");
      setDefaultDate([startDate, endDate]);
    }
  };

  function disableFutureDates(current) {
    const maxDate = startDate
      ? moment(startDate).add(1, "month")
      : moment().endOf("day");
    return current && (current > moment().endOf("day") || current > maxDate);
  }

  const handleCalendarChange = (dates) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
    }
  };

  const exportType = "csv";
  let fileName = `AI_REPORT_${moment(new Date()).format("DD-MM-YYYY_HH:mm")}`;

  const downloadCSV = async () => {
    const flattenArray = (data) => {
      if (!data) return [];
      return data.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            } else if (Array.isArray(obj[key])) {
              console.log("inside array key", obj[key]);
              flatObject[key] = obj[key].toString();
            }
          });
        }

        flatten(ele);
        return flatObject;
      });
    };

    try {
      setLoad(true);
      const csvData = await loadCSV();
      if (csvData.length === 0) {
        return message.error("No data found.", 2);
      }
      const data = flattenArray(csvData);
      exportFromJSON({ data, fileName, exportType });
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.", 2);
    } finally {
      setLoad(false);
    }
  };

  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="AI Report">
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          {canViewAiReport ? (
            <Card title="AI Report">
              <div className="row bg-white cursor-pointer">
                <div className="col-md-4">
                  <label>
                    Select Date <span style={{ color: "red" }}>*</span>
                  </label>
                  <RangePicker
                    format="YYYY-MM-DD"
                    style={{ width: "100%" }}
                    onChange={handleDate}
                    onCalendarChange={handleCalendarChange}
                    disabledDate={disableFutureDates}
                    clearIcon={false}
                  />
                </div>
                {canDownloadAiReport && (
                  <div className="col-md-2 d-flex align-items-end">
                    <button
                      className={`btn ${
                        defaultDate.length !== 2 ? "btn-secondary" : "btn-primary"
                      }  btn-block`}
                      onClick={downloadCSV}
                      disabled={defaultDate.length !== 2}
                    >
                      Download CSV
                    </button>
                  </div>
                )}
              </div>
            </Card>
          ) : (
            !load && <Card>You are not authorized to view this report.</Card>
          )}
        </Dashboard>
      )}
    </div>
  );
};

export default OCRReport;
